export default __webpack_public_path__ + "static/media/harrow.bb3f966d.svg";